// Open external links in a new tab
document.addEventListener('DOMContentLoaded', function () {
    // Get all links on the page
    const links = document.querySelectorAll('a');

    links.forEach(function(link) {
        // Check if the link is external
        const href = link.getAttribute('href');
        if (href && href.startsWith('http') && !href.includes(window.location.hostname)) {
            // Set the target attribute to open in a new tab
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');  // For security reasons
        }
    });
});